import { Maybe, Model, Product, ProductProperties } from 'src/types';
import { CurrentCampaign, RouteSection } from '../../types';

export interface IProductPageTabsProps {
  routeSection: RouteSection;
  product: Product & Maybe<{ coreProperties: ProductProperties }>;
  recommendations: Maybe<Model[]>;
  currentCampaign: CurrentCampaign;
  trendingProducts: Product['trendingProducts'];
}

export interface IProductTabMainProps {
  product: Product & Maybe<{ coreProperties: ProductProperties }>;
  recommendations: Maybe<Model[]>;
  trendingProducts: Product['trendingProducts'];
  currentCampaign: any;
}

export enum TabAnchor {
  ALL = '#all',
  PROPERTIES = '#properties',
  REVIEWS = '#reviews',
  STATISTICS = '#statistics',
}
